/* eslint import/prefer-default-export: 0 */
import * as t from './action_types';

const initialState = {
  imageError: null,
  imageState: null,
};

export const imageError = (state = initialState.imageError, action) => {
  switch (action.type) {
    case t.COMPANY_IMAGE_SAVING:
      return null;
    case t.COMPANY_IMAGE_SUCCESS:
      return null;
    case t.COMPANY_IMAGE_FAILURE:
      return action.message;
    case t.UNLOAD_COMPANY_IMAGE:
      return initialState.imageError;
    default:
      return state;
  }
};

export const imageState = (state = initialState.imageState, action) => {
  switch (action.type) {
    case t.COMPANY_IMAGE_EDITING:
      return 'editing';
    case t.COMPANY_IMAGE_CANCEL_EDITING:
      return initialState.imageState;
    case t.COMPANY_IMAGE_SAVING:
      return 'saving';
    case t.COMPANY_IMAGE_FAILURE:
      return 'error';
    case t.COMPANY_IMAGE_SUCCESS:
      return initialState.imageState;
    default:
      return state;
  }
};
